import { getCurrentCulture } from "@utils/common/culture";
import { isGamesTheme } from "@utils/common/theme";

export function isCasinoHeader(): boolean {
	return (
		isGamesTheme() ||
		window.location.pathname.includes(`/${getCurrentCulture()}/games`) ||
		window.location.pathname.includes(`/${getCurrentCulture()}/live-games`)
	);
}

export function formatTime(value: number): string {
	return value < 10 ? `0${value}` : `${value}`;
}

export function calculateTimeLeft(expireTime: number) {
	const currentTime = new Date().getTime();
	const expireTimeLeft = expireTime - currentTime;

	const timeLeft = { minutes: 0, seconds: 0 };

	if (expireTimeLeft > 0) {
		timeLeft.minutes = Math.floor(
			(expireTimeLeft % (1000 * 60 * 60)) / (1000 * 60)
		);
		timeLeft.seconds = Math.floor((expireTimeLeft % (1000 * 60)) / 1000);
	}

	return timeLeft;
}
